import { render, staticRenderFns } from "./MileageSummary.vue?vue&type=template&id=387b46dc&scoped=true"
import script from "./MileageSummary.vue?vue&type=script&lang=js"
export * from "./MileageSummary.vue?vue&type=script&lang=js"
import style0 from "./MileageSummary.vue?vue&type=style&index=0&id=387b46dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387b46dc",
  null
  
)

export default component.exports